import {List} from 'immutable';
import {Types} from 'Models/TerminalInstallationModel'
import {EnumTypes} from 'Models/EnumTypes/TerminalInstallationEnumTypes'
import {TerminalInstallationAction} from "Redux/Actions/Models/TerminalInstallationActionsModel";
import * as ActionTypes from "Redux/Actions/EnumTypes/ActionEnumTypes";

export type State = Types.TerminalInstallationStore;
export const TerminalInstallationInitialState = {
    terminalInstallationOrderList: [],
    terminalInstallationOrderActive: null,
    terminalInstallationOneElement: null,
    technicians: List([]),
    terminalInstallationOrderHistoryList: [],
    terminalInstallationNotesList: [],
    historyLoader: EnumTypes.HistoryRequestStatus.SHOW,
    historyCommentsId: null,
    terminalInstallationTotalCount: 0
};

export function terminalInstallationReducer(state: State = TerminalInstallationInitialState, action: TerminalInstallationAction): State {
    switch (action.type) {
        case ActionTypes.TerminalInstallation.GET_TERMINAL_INSTALLATION_ORDER_SUCCESS: {
            return {
                ...state,
                terminalInstallationOrderList: [...state.terminalInstallationOrderList, ...action.payload.terminalInstallationOrderList]
            };
        }
        case ActionTypes.TerminalInstallation.GET_TERMINAL_INSTALLATION_ORDER_WITH_FILTERS_SUCCESS: {
            return {
                ...state,
                terminalInstallationOrderList: action.payload.terminalInstallationOrderList
            };
        }
        case ActionTypes.TerminalInstallation.GET_TERMINAL_INSTALLATION_TOTAL_COUNT_SUCCESS: {
            return {
                ...state,
                terminalInstallationTotalCount: action.payload.terminalInstallationTotalCount
            };
        }
        case ActionTypes.TerminalInstallation.SET_ACTIVE: {
            return {
                ...state,
                terminalInstallationOrderActive: action.payload.id
            };
        }
        case ActionTypes.TerminalInstallation.SET_TERMINAL_INSTALLATION_ONE_ELEMENT: {
            return {
                ...state,
                terminalInstallationOneElement: action.payload.terminalInstallationOneElement
            };
        }
        case ActionTypes.TerminalInstallation.SET_TECHNICIAN_LIST: {
            return {
                ...state,
                technicians: List(action.payload.technicians)
            };
        }
        case ActionTypes.TerminalInstallation.SET_HISTORY_SUCCESS: {
            return {
                ...state,
                terminalInstallationOrderHistoryList: action.payload.terminalInstallationOrderHistory,
                historyLoader: EnumTypes.HistoryRequestStatus.HIDDEN
            };
        }
        case ActionTypes.TerminalInstallation.SET_HISTORY_ERROR: {
            return {
                ...state,
                historyLoader: EnumTypes.HistoryRequestStatus.HIDDEN
            };
        }
        case ActionTypes.TerminalInstallation.SET_STATUS_HISTORY_LOADER: {
            return {
                ...state,
                historyLoader: action.payload.status
            };
        }
        case ActionTypes.TerminalInstallation.SET_HISTORY_COMMENTS: {
            return {
                ...state,
                historyCommentsId: action.payload.terminalInstallationOrder.id
            };
        }
        case ActionTypes.TerminalInstallation.SET_TERMINAL_NOTES_LIST: {
            return {
                ...state,
                terminalInstallationNotesList: action.payload.notes
            };
        }
        case ActionTypes.TerminalInstallation.UPDATE_TERMINAL_NOTES_LIST: {
            return {
                ...state,
                terminalInstallationNotesList: state.terminalInstallationNotesList.concat(action.payload.note)
            };
        }
        default: {
            return {
                ...state
            };
        }
    }
}



// WEBPACK FOOTER //
// ./src/Redux/Reducers/TerminalInstallationReducer.ts